import { render, staticRenderFns } from "./fault-detail-modal.component.vue?vue&type=template&id=2af2e8aa"
import script from "./fault-detail-modal.component.vue?vue&type=script&lang=js"
export * from "./fault-detail-modal.component.vue?vue&type=script&lang=js"
import style0 from "./fault-detail-modal.component.vue?vue&type=style&index=0&id=2af2e8aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports